import { render, staticRenderFns } from "./FreeShiftConfigurator.vue?vue&type=template&id=2d034df3&scoped=true&lang=pug&"
import script from "./FreeShiftConfigurator.vue?vue&type=script&lang=ts&"
export * from "./FreeShiftConfigurator.vue?vue&type=script&lang=ts&"
import style0 from "./FreeShiftConfigurator.vue?vue&type=style&index=0&id=2d034df3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d034df3",
  null
  
)

export default component.exports